// Refactor: throttling via requestAnimationFrame + hover-intent (delay + cancel)
// Objectif: éviter les mouseenter/mouseleave trop "nerveux" sur header/menu/icônes

function headerListeners() {
    const body = document.querySelector("body");
    const header = document.querySelector("header");
    const searchInput = document.querySelector("input#search_home");
    const searchFieldWrapper = document.querySelector(".wrapper-search-field");
    const topWishlist = document.querySelector(".top-wishlist");
    const topAccount = document.querySelector(".top-account");
    const topCart = document.querySelector(".top-cart");
    const mainMenu = document.querySelector(".main-menu");
    const burgerMenu = document.querySelector(".burger-menu");
    const mainMenuWrapper = document.querySelector(".rollover-menu-wrapper");

    // -----------------------------
    // Helpers
    // -----------------------------

    // Throttle any function to 1 call per frame
    function rafThrottle(fn) {
        let rafId = 0;
        let lastArgs = null;

        return function throttled(...args) {
            lastArgs = args;
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                fn.apply(this, lastArgs);
            });
        };
    }

    // Hover intent: apply only if pointer stays a bit (prevents "tempestive" enter)
    function createHoverIntent({
        enterDelay = 60,
        leaveDelay = 40,
        onEnter,
        onLeave,
    }) {
        let enterT = 0;
        let leaveT = 0;
        let inside = false;

        const cancelEnter = () => {
            if (enterT) clearTimeout(enterT);
            enterT = 0;
        };
        const cancelLeave = () => {
            if (leaveT) clearTimeout(leaveT);
            leaveT = 0;
        };

        const scheduleEnter = () => {
            cancelLeave();
            cancelEnter();
            enterT = setTimeout(() => {
                enterT = 0;
                if (!inside) return;
                onEnter && onEnter();
            }, enterDelay);
        };

        const scheduleLeave = () => {
            cancelEnter();
            cancelLeave();
            leaveT = setTimeout(() => {
                leaveT = 0;
                if (inside) return;
                onLeave && onLeave();
            }, leaveDelay);
        };

        return {
            pointerEnter() {
                inside = true;
                scheduleEnter();
            },
            pointerLeave() {
                inside = false;
                scheduleLeave();
            },
            cancel() {
                cancelEnter();
                cancelLeave();
            },
        };
    }

    function isModalOpen() {
        return !!document.querySelector(".modal[modal-open]");
    }

    function isSearchVisible() {
        return !!document.querySelector(".wrapper-search-field[is-visible]");
    }

    // -----------------------------
    // Scroll listener (raf-throttled)
    // -----------------------------
    function scrollListener() {
        if (window.scrollY > 1) {
            if (header.hasAttribute("customization-transparent-state")) {
                header.removeAttribute("customization-transparent-state");
            }
            header.removeAttribute("customization-initial-state");
            header.setAttribute("customization-scroll-state", "");
        } else {
            if (body.classList.contains("homepage")) {
                header.setAttribute("customization-transparent-state", "");
            } else {
                header.setAttribute("customization-initial-state", "");
            }
            header.removeAttribute("customization-scroll-state");
        }

        // scroll direction tracking
        if (window.scrollY > 20 && window.scrollY > (window.lastScrollY || 0)) {
            body.setAttribute("scrolled-down", "");
        } else {
            body.removeAttribute("scrolled-down");
        }
        window.lastScrollY = window.scrollY;

        if (window.scrollY > 20) {
            body.setAttribute("hidden-pre-header", "");
        } else {
            body.removeAttribute("hidden-pre-header");
        }
    }

    const onScroll = rafThrottle(scrollListener);
    scrollListener(); // initial
    window.addEventListener("scroll", onScroll, { passive: true });

    // -----------------------------
    // Header hover intent (desktop)
    // -----------------------------
    const headerHover = createHoverIntent({
        enterDelay: 0,
        leaveDelay: 60,
        onEnter: rafThrottle(() => {
            if (is_mobile) return;

            if (header.hasAttribute("customization-initial-state")) {
                header.removeAttribute("customization-initial-state");
            } else if (header.hasAttribute("customization-transparent-state")) {
                header.removeAttribute("customization-transparent-state");
            }
            header.setAttribute("customization-hover-state", "");
        }),
        onLeave: rafThrottle(() => {
            if (is_mobile) return;
            if (header.hasAttribute("menu-open")) return;

            header.removeAttribute("customization-hover-state");

            if (!header.hasAttribute("customization-scroll-state")) {
                if (body.classList.contains("homepage") && window.scrollY <= 1) {
                    header.setAttribute("customization-transparent-state", "");
                } else {
                    header.setAttribute("customization-initial-state", "");
                }
            }
        }),
    });

    header.addEventListener("mouseenter", () => headerHover.pointerEnter());
    header.addEventListener("mouseleave", () => headerHover.pointerLeave());

    // Check if mouse is already in header on load
    const checkInitialMousePosition = (e) => {
        if (!is_mobile && header) {
            const rect = header.getBoundingClientRect();
            if (e.clientX >= rect.left && e.clientX <= rect.right &&
                e.clientY >= rect.top && e.clientY <= rect.bottom) {
                headerHover.pointerEnter();
            }
        }
    };

    // Listen for first mousemove to detect initial position
    document.addEventListener("mousemove", function initialMouseCheck(e) {
        checkInitialMousePosition(e);
        document.removeEventListener("mousemove", initialMouseCheck);
    }, { once: true, passive: true });

    // -----------------------------
    // Main menu hover intent (desktop)
    // -----------------------------
    let mainMenuHover = null;

    if (mainMenu) {
        mainMenuHover = createHoverIntent({
            // enterDelay: 60,
            enterDelay: 0,
            leaveDelay: 60,
            onEnter: rafThrottle(() => {
                if (isModalOpen()) return;
                if (isSearchVisible()) return;
                toggleBackdrop(1);
            }),
            onLeave: rafThrottle(() => {
                if (isModalOpen()) return;
                if (isSearchVisible()) return;
                if (header.hasAttribute("menu-open")) return;
                toggleBackdrop(0);
            }),
        });

        mainMenu.addEventListener("mouseenter", () => mainMenuHover.pointerEnter());
        mainMenu.addEventListener("mouseleave", () => mainMenuHover.pointerLeave());

        // -----------------------------
        // Mobile menu listeners
        // -----------------------------
        if (burgerMenu) {
            const toggleMenu = async () => {
                if (header.hasAttribute("menu-open")) {
                    await hideMenu();
                } else {
                    displayMenu();
                }
            };

            burgerMenu.addEventListener("click", toggleMenu);
        }

        async function displayMenu() {
            hideRollover(topWishlist);
            hideRollover(topAccount);
            hideRollover(topCart);
            await closeSearch();

            document.body.setAttribute("has-scroll-locked", "");
            burgerMenu.setAttribute("is-open", "");
            header.setAttribute("menu-open", "");
            mainMenuWrapper.setAttribute("is-displayed", "");
            toggleBackdrop(1);

            // Force backdrop to be displayed for mobile menu
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.setAttribute("is-displayed", "");
                backdrop.addEventListener("click", async () => {
                    await hideMenu();
                }, { once: true });
            }

            // Set the body to has-scroll-locked to prevent scroll
            document.body.setAttribute("has-scroll-locked", "");
        }

        async function hideMenu() {
            document.body.removeAttribute("has-scroll-locked");
            burgerMenu.removeAttribute("is-open");

            if (body.classList.contains("homepage") && window.scrollY <= 1) {
                header.setAttribute("customization-transparent-state", "");
            } else if (window.scrollY > 1) {
                header.setAttribute("customization-scroll-state", "");
            }

            header.removeAttribute("menu-open");
            removeAttributes(mainMenuWrapper, ["is-displayed", "is-boutique"]);
            toggleBackdrop(0);

            // Remove the scroll lock on body
            document.body.removeAttribute("has-scroll-locked");
        }

        // Expose to inner helpers
        window.__headerHideMenu = hideMenu;
        window.__headerDisplayMenu = displayMenu;
    }

    // Use local functions but fallback to window (for safety if called before definition)
    function displayMenu() {
        if (typeof window.__headerDisplayMenu === "function") window.__headerDisplayMenu();
    }
    async function hideMenu() {
        if (typeof window.__headerHideMenu === "function") await window.__headerHideMenu();
    }

    // -----------------------------
    // Search listeners
    // -----------------------------
    async function displaySearch() {
        hideRollover(topWishlist);
        hideRollover(topAccount);
        hideRollover(topCart);

        await hideMenu();

        header.setAttribute("is-searching", "");
        searchFieldWrapper.setAttribute("is-visible", "");
        searchInput.focus();

        // Click backdrop to close (avoid stacking multiple listeners)
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
            backdrop.addEventListener(
                "click",
                async () => {
                    await closeSearch();
                },
                { once: true }
            );
        }

        // Set the body to has-scroll-locked to prevent scroll
        document.body.setAttribute("has-scroll-locked", "");

        if (isModalOpen()) return;
        toggleBackdrop(1);
    }

    async function closeSearch() {
        if (body.classList.contains("homepage") && window.scrollY <= 1) {
            header.removeAttribute("customization-initial-state");
            header.setAttribute("customization-transparent-state", "");
        }

        header.removeAttribute("is-searching");
        searchFieldWrapper.removeAttribute("is-visible");
        searchInput.value = "";
        toggleBackdrop(0);

        // Remove the scroll lock on body
        document.body.removeAttribute("has-scroll-locked");
    }

    const triggerRecherche = document.querySelector(".trigger-recherche");
    const closeSearchBtn = document.querySelector(".close-search");
    if (triggerRecherche) triggerRecherche.addEventListener("click", async () => await displaySearch());
    if (closeSearchBtn) closeSearchBtn.addEventListener("click", async () => await closeSearch());

    document.addEventListener("click", async function (e) {
        if (e.target && e.target.classList && e.target.classList.contains("search-recap")) {
            await displaySearch();
        }
    });

    // -----------------------------
    // Icons listeners (hover intent on desktop)
    // -----------------------------
    const topRolloverHover = new Map();
    let isDisplayingRollover = false;

    async function displayRollover(elem) {
        if (!elem) return;
        if (elem.hasAttribute("is-displayed")) return;
        if (isDisplayingRollover) return; // Prevent concurrent calls

        isDisplayingRollover = true;

        await hideMenu();
        await closeSearch();

        checkWishProductStock();

        document
            .querySelectorAll(".top-wishlist[is-displayed], .top-account[is-displayed], .top-cart[is-displayed]")
            .forEach((el) => el.removeAttribute("is-displayed"));

        // Set attribute and toggle backdrop synchronously
        elem.setAttribute("is-displayed", "");
        header.setAttribute("has-rollover", "");
        toggleBackdrop(1); // TEMPORARILY DISABLED FOR DEBUG

        if (is_mobile) {
            document.body.setAttribute("has-scroll-locked", "");
        }

        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
            backdrop.addEventListener("click", async () => {
                hideRollover(elem);
            }, { once: true });
        }

        isDisplayingRollover = false;
    }

    function hideRollover(elem) {
        if (!elem) return;
        elem.removeAttribute("is-displayed");
        if (!header.hasAttribute("menu-open")) {
            toggleBackdrop(0);
        }
        header.removeAttribute("has-rollover");

        if (is_mobile) {
            document.body.removeAttribute("has-scroll-locked");
        }
    }

    function bindRolloverHover(elem) {
        if (!elem) return;

        const intent = createHoverIntent({
            enterDelay: 80,
            leaveDelay: 80,
            onEnter: rafThrottle(async () => await displayRollover(elem)),
            onLeave: rafThrottle(() => hideRollover(elem)),
        });

        topRolloverHover.set(elem, intent);

        elem.addEventListener("mouseenter", () => intent.pointerEnter());
        elem.addEventListener("mouseleave", () => intent.pointerLeave());
    }

    // Bind click handler for touch devices (works on both mobile and desktop with touch)
    // First tap shows rollover, second tap navigates
    const bindTouchRollover = (elem) => {
        const link = elem.querySelector('.top-icon');

        if (link) {
            link.addEventListener('click', async (e) => {
                // If rollover is not displayed, prevent navigation and show it
                if (!elem.hasAttribute('is-displayed')) {
                    e.preventDefault();
                    await displayRollover(elem);
                }
                // If rollover is already displayed, allow navigation
            });
        }
    };

    // Bind hover for desktop/pointer devices
    if (!is_mobile) {
        if (topWishlist) bindRolloverHover(topWishlist);

        if (topAccount && topAccount.hasAttribute("is-connected")) {
            bindRolloverHover(topAccount);
        }

        if (topCart) bindRolloverHover(topCart);
    }

    // Bind touch/click handlers for ALL devices (mobile and desktop touchscreens)
    if (topWishlist) bindTouchRollover(topWishlist);
    // Only bind touch rollover for account if logged in (has rollover menu)
    if (topAccount && topAccount.hasAttribute("is-connected")) bindTouchRollover(topAccount);
    if (topCart) bindTouchRollover(topCart);

    // -----------------------------
    // Closing top rollover via cross button
    // -----------------------------
    document.addEventListener("click", function (event) {
        if (!event.target || !event.target.matches(".top-rollover-close")) return;

        document.querySelector(".top-wishlist")?.removeAttribute("is-displayed");
        document.querySelector(".top-account")?.removeAttribute("is-displayed");
        document.querySelector(".top-cart")?.removeAttribute("is-displayed");

        if (is_mobile) {
            document.body.removeAttribute("has-scroll-locked");
        }

        if (header.hasAttribute("is-searching") || header.hasAttribute("menu-open")) return;
        toggleBackdrop(0);
    });

    document.querySelectorAll('.menu-super').forEach(menu => {
        menu.addEventListener('click', function(e) {
            if (header.hasAttribute('menu-open')) {
                e.preventDefault();
                document.querySelectorAll('.menu-super + .rollover-menu').forEach(openedMenu => {
                    openedMenu.removeAttribute("is-visible");
                });
                setTimeout(() => {
                    if (menu.nextElementSibling && !menu.nextElementSibling.hasAttribute('is-visible')) {
                        document.querySelector(".rollover-menu-wrapper").setAttribute("is-boutique", "");
                        menu.nextElementSibling.setAttribute("is-visible", "");
                        // Open first level of boutique menu by default when opening boutique section
                        menu.nextElementSibling.querySelector('.menu-boutique')?.setAttribute('is-opened', '');
                        slideDown(menu.nextElementSibling.querySelector('.sub-rayon'));
                    } else {
                        menu.nextElementSibling.removeAttribute("is-visible");
                        document.querySelector(".rollover-menu-wrapper").removeAttribute("is-boutique");
                    }
                }, 0);
            }
        });
    });

    document.querySelectorAll('.menu-return').forEach(menu => {
        menu.addEventListener('click', function(e) {
            if (header.hasAttribute('menu-open')) {
                e.preventDefault();
                document.querySelector('.rollover-menu[is-visible]').removeAttribute("is-visible");
                document.querySelector(".rollover-menu-wrapper").removeAttribute("is-boutique");
                document.querySelector('.menu-boutique[is-opened]')?.removeAttribute('is-opened');
                document.querySelectorAll('.sub-rayon').forEach(submenu => {
                    slideUp(submenu);
                });
            }
        });
    });

    document.querySelectorAll('.menu-boutique').forEach(menu => {
        menu.addEventListener('click', function(e) {
            if (header.hasAttribute('menu-open')) {
                const subRayon = menu.nextElementSibling;
                e.preventDefault();

                if (menu.hasAttribute('is-opened')) {
                    menu.removeAttribute('is-opened');
                    slideUp(subRayon);
                    return
                }

                document.querySelectorAll('.sub-rayon').forEach(submenu => {
                    document.querySelectorAll('.menu-boutique').forEach(openedMenu => {
                        openedMenu.removeAttribute('is-opened');
                    });
                    slideUp(submenu);
                });

                setTimeout(() => {
                    if (subRayon) {
                        menu.setAttribute('is-opened', '');
                        slideDown(subRayon);
                    }
                }, 0);
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", () => {
    headerListeners();
});